if (!customElements.get("zinney-reviews")) {
  customElements.define(
    "zinney-reviews",
    class ZinneyReviews extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === "true") return;
        this.dataset.initialized = "true";

        this.track = this.querySelector("[data-review-track]");
        this.deferredTemplates = Array.from(
          this.querySelectorAll("[data-review-deferred-template]"),
        );
        this.loadMoreButton = this.querySelector("[data-review-load-more]");
        this.loadMoreWrap = this.querySelector("[data-review-load-more-wrap]");
        this.allCards = Array.from(
          this.querySelectorAll(".zinney-review-card"),
        );
        this.cards = this.allCards;
        this.filterButtons = Array.from(
          this.querySelectorAll("[data-review-filter]"),
        );
        this.mediaButtons = Array.from(
          this.querySelectorAll("[data-review-media-open]"),
        );
        this.dots = Array.from(this.querySelectorAll("[data-review-dot]"));
        this.previousButton = this.querySelector("[data-review-previous]");
        this.nextButton = this.querySelector("[data-review-next]");
        this.dialog = this.querySelector("[data-review-dialog]");
        this.dialogContent = this.querySelector(
          "[data-review-dialog-content]",
        );
        this.closeButton = this.querySelector("[data-review-dialog-close]");
        this.dialogPreviousButton = this.querySelector(
          "[data-review-dialog-previous]",
        );
        this.dialogNextButton = this.querySelector(
          "[data-review-dialog-next]",
        );

        this.onPrevious = () => this.scrollReviews(-1);
        this.onNext = () => this.scrollReviews(1);
        this.onTrackScroll = () => this.scheduleNavigationUpdate();
        this.onResize = () => this.updateNavigation();
        this.onDialogPrevious = () => this.stepMedia(-1);
        this.onDialogNext = () => this.stepMedia(1);
        this.onCloseClick = () => this.closeDialog();
        this.onDialogBackdrop = (event) => {
          if (event.target === this.dialog) this.closeDialog();
        };
        this.onDialogClose = () => this.resetDialog();
        this.onMediaClick = (event) => {
          const button = event.target.closest("[data-review-media-open]");
          if (button && this.contains(button)) this.openMedia(button);
        };
        this.onDotClick = (event) => {
          const dot = event.target.closest("[data-review-dot]");
          if (!dot) return;
          this.scrollToReview(Number(dot.dataset.reviewDot || 0));
        };
        this.onDialogContentClick = (event) => {
          const thumbnail = event.target.closest("[data-review-gallery-thumb]");
          if (!thumbnail) return;
          this.selectMedia(Number(thumbnail.dataset.reviewGalleryThumb || 0));
        };
        this.onFilterClick = (event) => {
          const button = event.target.closest("[data-review-filter]");
          if (!button) return;
          this.applyFilter(button.dataset.reviewFilter || "all");
        };
        this.onLoadMore = () => this.loadDeferredReviews();

        this.previousButton?.addEventListener("click", this.onPrevious);
        this.nextButton?.addEventListener("click", this.onNext);
        this.track?.addEventListener("scroll", this.onTrackScroll, {
          passive: true,
        });
        this.track?.addEventListener("click", this.onMediaClick);
        this.querySelector("[data-review-pagination]")?.addEventListener(
          "click",
          this.onDotClick,
        );
        this.querySelector("[data-review-filters]")?.addEventListener(
          "click",
          this.onFilterClick,
        );
        this.loadMoreButton?.addEventListener("click", this.onLoadMore);
        this.closeButton?.addEventListener("click", this.onCloseClick);
        this.dialogPreviousButton?.addEventListener(
          "click",
          this.onDialogPrevious,
        );
        this.dialogNextButton?.addEventListener(
          "click",
          this.onDialogNext,
        );
        this.dialog?.addEventListener("click", this.onDialogBackdrop);
        this.dialogContent?.addEventListener(
          "click",
          this.onDialogContentClick,
        );
        this.dialog?.addEventListener("close", this.onDialogClose);
        this.dialog?.addEventListener("cancel", this.onDialogClose);

        if ("ResizeObserver" in window && this.track) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener("resize", this.onResize);
        }

        this.applyFilter(this.dataset.initialReviewFilter || "all");
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener("click", this.onPrevious);
        this.nextButton?.removeEventListener("click", this.onNext);
        this.track?.removeEventListener("scroll", this.onTrackScroll);
        this.track?.removeEventListener("click", this.onMediaClick);
        this.querySelector("[data-review-pagination]")?.removeEventListener(
          "click",
          this.onDotClick,
        );
        this.querySelector("[data-review-filters]")?.removeEventListener(
          "click",
          this.onFilterClick,
        );
        this.loadMoreButton?.removeEventListener("click", this.onLoadMore);
        this.closeButton?.removeEventListener("click", this.onCloseClick);
        this.dialogPreviousButton?.removeEventListener(
          "click",
          this.onDialogPrevious,
        );
        this.dialogNextButton?.removeEventListener(
          "click",
          this.onDialogNext,
        );
        this.dialog?.removeEventListener("click", this.onDialogBackdrop);
        this.dialogContent?.removeEventListener(
          "click",
          this.onDialogContentClick,
        );
        this.dialog?.removeEventListener("close", this.onDialogClose);
        this.dialog?.removeEventListener("cancel", this.onDialogClose);
        this.resizeObserver?.disconnect();
        window.removeEventListener("resize", this.onResize);
      }

      applyFilter(model) {
        const selectedModel = model || "all";
        this.currentFilter = selectedModel;
        this.allCards.forEach((card) => {
          const cardModel = card.dataset.reviewModel || "manual";
          card.hidden = selectedModel !== "all" && cardModel !== selectedModel;
        });
        this.cards = this.allCards.filter((card) => !card.hidden);
        this.filterButtons.forEach((button) => {
          const isActive = button.dataset.reviewFilter === selectedModel;
          button.classList.toggle("is-active", isActive);
          button.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
        this.track?.scrollTo({ left: 0, behavior: "auto" });
        requestAnimationFrame(() => this.updateNavigation());
      }

      loadDeferredReviews() {
        if (!this.deferredTemplates.length || !this.track) return;
        this.loadMoreButton?.setAttribute("aria-busy", "true");
        this.deferredTemplates.forEach((template) => {
          this.track.append(template.content.cloneNode(true));
          template.remove();
        });
        this.deferredTemplates = [];
        this.allCards = Array.from(
          this.querySelectorAll(".zinney-review-card"),
        );
        if (this.loadMoreWrap) this.loadMoreWrap.hidden = true;
        this.applyFilter(this.currentFilter || "all");
      }

      cardDistance() {
        if (!this.track) return 0;
        const card = this.cards[0];
        const trackStyle = getComputedStyle(this.track);
        const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || 0);
        return card
          ? card.getBoundingClientRect().width + gap
          : this.track.clientWidth;
      }

      scrollReviews(direction) {
        if (!this.track) return;
        this.track.scrollBy({
          left: this.cardDistance() * direction,
          behavior: this.prefersReducedMotion() ? "auto" : "smooth",
        });
      }

      scrollToReview(index) {
        if (!this.track || !this.cards[index]) return;
        this.track.scrollTo({
          left: this.cardDistance() * index,
          behavior: this.prefersReducedMotion() ? "auto" : "smooth",
        });
      }

      prefersReducedMotion() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      }

      scheduleNavigationUpdate() {
        if (this.navigationFrame) return;
        this.navigationFrame = requestAnimationFrame(() => {
          this.navigationFrame = null;
          this.updateNavigation();
        });
      }

      updateNavigation() {
        if (!this.track) return;
        if (!this.cards.length) {
          if (this.previousButton) this.previousButton.disabled = true;
          if (this.nextButton) this.nextButton.disabled = true;
          return;
        }
        const maximumScroll = Math.max(
          0,
          this.track.scrollWidth - this.track.clientWidth,
        );
        const currentScroll = Math.abs(this.track.scrollLeft);
        if (this.previousButton) {
          this.previousButton.disabled = currentScroll <= 2;
        }
        if (this.nextButton) {
          this.nextButton.disabled = currentScroll >= maximumScroll - 2;
        }

        const distance = this.cardDistance();
        const activeIndex = distance
          ? Math.min(
              this.cards.length - 1,
              Math.max(0, Math.round(currentScroll / distance)),
            )
          : 0;
        this.dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle("is-active", isActive);
          dot.setAttribute("aria-current", isActive ? "true" : "false");
        });
      }

      openMedia(button) {
        this.activeMediaButton = button;
        this.renderDialog();
        if (!this.dialog) return;

        if (typeof this.dialog.showModal === "function") {
          if (!this.dialog.open) this.dialog.showModal();
        } else {
          this.dialog.setAttribute("open", "");
        }

        document.body.classList.add("zinney-review-dialog-open");
        this.syncGalleryMedia();
        this.closeButton?.focus();
      }

      renderDialog() {
        if (
          !this.dialogContent ||
          !this.activeMediaButton
        ) {
          return;
        }

        const card = this.activeMediaButton.closest(".zinney-review-card");
        const template = card?.querySelector("[data-review-media-template]");
        const details = card?.querySelector(".zinney-review-card__content");
        if (!template) return;

        this.dialogContent.querySelectorAll("video").forEach((video) => {
          video.pause();
        });

        const media = document.createElement("div");
        media.className = "zinney-review-dialog__media";
        media.append(template.content.cloneNode(true));

        const detailsClone = details?.cloneNode(true);
        if (detailsClone) {
          detailsClone.classList.add("zinney-review-dialog__details");
          detailsClone.querySelectorAll("[id]").forEach((element) => {
            element.removeAttribute("id");
          });
          this.dialogContent.replaceChildren(media, detailsClone);
        } else {
          this.dialogContent.replaceChildren(media);
        }

        this.galleryStage?.removeEventListener(
          "scroll",
          this.onGalleryScroll,
        );
        this.galleryStage = this.dialogContent.querySelector(
          "[data-review-gallery-stage]",
        );
        this.galleryItems = Array.from(
          this.dialogContent.querySelectorAll("[data-review-gallery-item]"),
        );
        this.galleryThumbs = Array.from(
          this.dialogContent.querySelectorAll("[data-review-gallery-thumb]"),
        );
        this.activeGalleryIndex = 0;
        const hasMultipleMedia = this.galleryItems.length > 1;
        if (this.dialogPreviousButton) {
          this.dialogPreviousButton.hidden = !hasMultipleMedia;
        }
        if (this.dialogNextButton) {
          this.dialogNextButton.hidden = !hasMultipleMedia;
        }
        this.onGalleryScroll = () => {
          if (this.galleryFrame) return;
          this.galleryFrame = requestAnimationFrame(() => {
            this.galleryFrame = null;
            this.updateGalleryFromScroll();
          });
        };
        this.galleryStage?.addEventListener(
          "scroll",
          this.onGalleryScroll,
          { passive: true },
        );
        this.updateGalleryState(0);
      }

      stepMedia(direction) {
        if (!this.galleryItems?.length) return;
        const nextIndex =
          (this.activeGalleryIndex + direction + this.galleryItems.length) %
          this.galleryItems.length;
        this.selectMedia(nextIndex);
      }

      selectMedia(index) {
        if (!this.galleryStage || !this.galleryItems?.[index]) return;
        this.updateGalleryState(index);
        this.galleryStage.scrollTo({
          left: this.galleryStage.clientWidth * index,
          behavior: this.prefersReducedMotion() ? "auto" : "smooth",
        });
      }

      updateGalleryFromScroll() {
        if (!this.galleryStage?.clientWidth) return;
        const index = Math.min(
          this.galleryItems.length - 1,
          Math.max(
            0,
            Math.round(
              Math.abs(this.galleryStage.scrollLeft) /
                this.galleryStage.clientWidth,
            ),
          ),
        );
        this.updateGalleryState(index);
      }

      updateGalleryState(index) {
        this.activeGalleryIndex = index;
        this.galleryThumbs?.forEach((thumbnail, thumbnailIndex) => {
          const isActive = thumbnailIndex === index;
          thumbnail.classList.toggle("is-active", isActive);
          thumbnail.setAttribute(
            "aria-current",
            isActive ? "true" : "false",
          );
        });
        this.syncGalleryMedia();
      }

      syncGalleryMedia() {
        this.galleryItems?.forEach((item, index) => {
          const video = item.querySelector("video");
          if (!video) return;
          if (index === this.activeGalleryIndex && this.dialog?.open) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      closeDialog() {
        if (!this.dialog) return;
        if (typeof this.dialog.close === "function" && this.dialog.open) {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute("open");
          this.resetDialog();
        }
      }

      resetDialog() {
        this.galleryStage?.removeEventListener(
          "scroll",
          this.onGalleryScroll,
        );
        this.dialogContent?.querySelectorAll("video").forEach((video) => {
          video.pause();
        });
        this.dialogContent?.replaceChildren();
        this.activeMediaButton = null;
        this.galleryStage = null;
        this.galleryItems = [];
        this.galleryThumbs = [];
        this.activeGalleryIndex = 0;
        document.body.classList.remove("zinney-review-dialog-open");
      }
    },
  );
}
